// Generated by scripts/build-info.mjs - do not edit, not committed.
export const BUILD_INFO = {
  sha: '2df57d79a907802418b8a93cdb051a1a7b7fcf73',
  short: '2df57d7',
  builtAt: '2026-11-04T08:03:21.934Z',
} as const;
